module.exports = uiitemsubmissionMfeConfig;